<template>
  <div>
    <form :action="$appConfig.GMOMemberEdit" method="POST">
      <div style="display: none;">
        <input type="text" name="SiteID" :value="params.siteId" />
        <input type="text" name="MemberID" :value="params.memberId" />
        <input type="text" name="MemberName" :value="params.memberName" />
        <input type="text" name="ShopID" :value="params.shopId" />
        <input type="text" name="MemberPassString" :value="params.memberPassString" />
        <input type="text" name="RetURL" :value="params.retUrl" />
        <input type="text" name="DateTime" :value="params.dateTime" />
      </div>
      <div>
        <p>{{ $t('GMOのクレジットカード登録画面に自動的に画面が切り替わります。') }}</p>
        <p>{{ $t('画面が切り替わらない場合は、以下のボタンを押してください') }}</p>
        <b-button
          variant="primary"
          type="submit"
          ref="register"
        >{{ $t('カード登録画面へ') }}</b-button>
      </div>
    </form>
  </div>
</template>

<script>
import qs from 'querystringify'

export default {
  data() {
    return {
      params: {
        siteId: '',
        memberId: '',
        memberName: '',
        shopID: '',
        memberPassString: '',
        retURL: '',
        dateTime: '',
      },
      pageTitle: '',
    }
  },
  mounted() {
    setTimeout(() => {
      this.$refs.register.click()
    }, 3000)
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  async created() {
    const query = qs.parse(location.search)
    this.params.siteId = query.site_id || ''
    this.params.memberId = query.member_id || ''
    this.params.memberName = query.member_name || ''
    this.params.shopId = query.shop_id || ''
    this.params.memberPassString = query.member_pass_string || ''
    this.params.retUrl = query.ret_url || ''
    this.params.dateTime = query.date_time || ''
  },
}
</script>
